import { render, staticRenderFns } from "./PDisplayInfo.vue?vue&type=template&id=85bdf7c6"
import script from "./PDisplayInfo.vue?vue&type=script&lang=js"
export * from "./PDisplayInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports